// @ts-nocheck
import { Column } from 'react-table'
import { ResellerGroupInfoCell } from './ResellerGroupInfoCell'
import { ResellerGroupActionsCell } from './ResellerGroupActionsCell'
import { ResellerGroupSelectionCell } from './ResellerGroupSelectionCell'
import { ResellerGroupCustomHeader } from './ResellerGroupCustomHeader'
import { ResellerGroupSelectionHeader } from './ResellerGroupSelectionHeader'
import { ResellerGroup } from '../../core/_models'
import { FormattedMessage } from 'react-intl'

const resellergroupsColumns: ReadonlyArray<Column<ResellerGroup>> = [
  {
    Header: (props) => <ResellerGroupSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <ResellerGroupSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLERGROUP.TABLE.COLUMN.GROUPNAME" defaultMessage="Group Name" />}
        className="min-w-125px"
      />
    ),
    id: 'name',
    accessor: 'name',
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLERGROUP.TABLE.COLUMN.DISCOUNTTYPE" defaultMessage="Discount Type" />}
        className="min-w-125px"
      />
    ),
    id: 'discount_type',
    accessor: 'discount_type',
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLERGROUP.TABLE.COLUMN.DISCOUNTVALUE" defaultMessage="Discount Value" />}
        className="min-w-100px"
      />
    ),
    id: 'discount_value',
    accessor: 'discount_value',
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLERGROUP.TABLE.COLUMN.SUBRESELLERLIMIT" defaultMessage="Sub Reseller Limit" />}
        className="min-w-100px"
      />
    ),
    id: 'sub_reseller_limit',
    accessor: 'sub_reseller_limit',
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLERGROUP.TABLE.COLUMN.CANADDSUBRESELLERS" defaultMessage="Can Add Sub-Resellers" />}
        className="min-w-100px"
      />
    ),
    id: 'can_create_sub_resellers',
    Cell: ({ row }) => (
      <span
        className={`badge ${
          row.original.can_create_sub_resellers ? 'badge-success' : 'badge-danger'
        }`}
      >
        {row.original.can_create_sub_resellers ? 'Yes' : 'No'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLERGROUP.TABLE.COLUMN.CANSUBRESELLERCREATESUBS" defaultMessage="Can Sub-Reseller Create Subs" />}
        className="min-w-150px"
      />
    ),
    id: 'can_sub_reseller_create_subs',
    Cell: ({ row }) => (
      <span
        className={`badge ${
          row.original.can_sub_reseller_create_subs ? 'badge-success' : 'badge-danger'
        }`}
      >
        {row.original.can_sub_reseller_create_subs ? 'Yes' : 'No'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLERGROUP.TABLE.COLUMN.STATUS" defaultMessage="Status" />}
        className="min-w-100px"
      />
    ),
    id: 'status',
    Cell: ({ row }) => (
      <span
        className={`badge ${
          row.original.status === 'active' ? 'badge-success' : 'badge-danger'
        }`}
      >
        {row.original.status === 'active' ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLERGROUP.TABLE.COLUMN.NOTES" defaultMessage="Notes" />}
        className="min-w-150px"
      />
    ),
    id: 'notes',
    accessor: 'notes',
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="RESELLERGROUP.TABLE.COLUMN.RESELLERGROUPDATE" defaultMessage="ResellerGroup Date" />}
        className="min-w-150px"
      />
    ),
    id: 'created_at',
    accessor: 'created_at',
  },
  {
    Header: (props) => (
      <ResellerGroupCustomHeader
        tableProps={props}
        title={<FormattedMessage id="TABLE.GENERAL.ACTION" defaultMessage="Action" />}
        className="text-end min-w-100px"
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <ResellerGroupActionsCell id={props.data[props.row.index].id} />,
  },
]

export { resellergroupsColumns }
